<a class="btn" [ngClass]="{'text-secondary': !isSelected, 'scheme-text-dark': isSelected}" (click)="clicked()">
  <div class="text-center d-flex flex-column">
    <i class="menu-icon" [ngClass]="iconClasses"></i>
    <div class="menu-label">{{ buttonText }}</div>
    @if (inBeta) {
      <shared-beta-pill [size]="6" class='mt-1'></shared-beta-pill>
    }
  </div>
</a>